import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/images/progress_left.png'
import _imports_1 from '@/images/sweet_stop.png'
import _imports_2 from '@/images/progress_right.png'


const _hoisted_1 = { class: "md:my-36 my-12 px-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center md:text-48px text-2xl font-inter-bold" }, " New Paradigm ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "md:text-2xl text-base md:mt-24 mt-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "md:text-xl text-14px text-everBlack1" }, " We’ve made a brand new development paradigm: "),
  /*#__PURE__*/_createElementVNode("div", { class: "text-everBlack1 font-inter-medium md:mt-4 mt-2" }, " Storage-based Consensus Paradigm (SCP): Simply put, it‘s data stored on-chain while being computed off-chain. ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-full md:rounded-2xl rounded-lg md:p-12 p-4 md:mt-12 mt-6 new_paradigm_banner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-everWhite1 pb-2" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "md:text-xl text-12px" }, " Why do we do this? "),
    /*#__PURE__*/_createElementVNode("div", { class: "mt-1 text-12px md:text-base" }, " To Find the sweet spot between Decentralization and Centralization. ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center md:px-8 px-1.5 w-full md:mt-32 mt-10 md:mb-8 mb-9" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "md:h-0.5 h-px w-29.5% md:w-28% rounded-l-sm bg-white relative text-white text-12px md:text-base" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        class: "md:w-8 md:h-8 w-3 h-3 absolute transform -translate-x-2/4 -translate-y-2/4",
        alt: "New Paradigm"
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "transform md:-translate-x-1/4 w-max md:-translate-y-20 -translate-x-1.5 -translate-y-9" }, " DECENTRALIZED ")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "md:border-2 border md:h-2.5 h-1 w-1 md:w-2.5 border-white border-solid rounded-full md:text-xl text-12px text-white font-inter-semiBold" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_1,
        class: "md:w-16 md:h-16 w-5 h-5 absolute sweet_stop",
        alt: "New Paradigm"
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "whitespace-nowrap transform w-max -translate-x-2/4 md:-translate-y-20 translate-y-5" }, " SWEET SPOT ")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "md:h-0.5 h-px w-full rounded-r-sm bg-white relative flex-1 flex justify-end text-white text-12px md:text-base" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_2,
        class: "md:w-8 md:h-8 w-3 h-3 absolute transform right-0 translate-x-2/4 -translate-y-2/4",
        alt: "New Paradigm"
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "transform md:translate-x-1/3 translate-x-2 w-max md:-translate-y-20 -translate-y-9" }, " CENTRALIZATION ")
    ])
  ])
], -1)

import Container from './Container.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'NewParadigm',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Container, null, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4
      ]),
      _: 1
    })
  ]))
}
}

})